/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Duration_DayInputs */

const en_task_duration_day = /** @type {(inputs: Task_Duration_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`day`)
};

const pt_br2_task_duration_day = /** @type {(inputs: Task_Duration_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dia`)
};

/**
* | output |
* | --- |
* | "day" |
*
* @param {Task_Duration_DayInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_duration_day = /** @type {((inputs?: Task_Duration_DayInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Duration_DayInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_duration_day(inputs)
	return pt_br2_task_duration_day(inputs)
});